import { Component, Inject } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { IBillingShippingModel, SCALRenewalType, SCALType } from "../../../interfaces/LicenseModel";
import { MD_DIALOG_DATA, MdDialogRef, MdSnackBar } from "@angular/material";
import { LicenseService } from "../../../services/LicenseService";
import { AppLoaderService } from "../../../../services/app-loader/app-loader.service";
import Swal from "sweetalert2";
import { Router } from "@angular/router";
import { AdalService } from "../../../shared/adal.service";

@Component({
    selector:'renew-scal360-license',
    template:require('./renew-scal360-license.component.html'),
    styles:[require('./renew-scal360-license.component.css')]
})

export class RenewScal360LicenseComponent{
    renewalType=SCALRenewalType;
    scalTypeEnum=SCALType;
    dialogTitle='Renew SCAL 360 License';
    errorMessage='';
    renewScal360LicenseForm:FormGroup;
    isRadioButtonDisabled=false;
    selectedRow;
    billingShippingDetail:IBillingShippingModel={
        ODataEtag:'',
        Number:'',
        publicId:'',
        CustomerNo:'',
        publicSalesPersoncode:'',
        BillToName:'',
        BillToAddress1:'',
        BillToAddress2:'',
        BillToCity:'',
        BillToState:'',
        BillToZipcode:'',
        BillToCountryCode:'',
        ShipToCode:'',
        ShipToName:'',
        ShipToAddress1:'',
        ShipToAddress2:'',
        ShipToCity:'',
        ShipToState:'',
        ShipToZipcode:'',
        ShipToCountryCode:'',
        CustomerTelephone:'',
        CustomerEmailAddress:'',
        CustomerFaxno:'',
        ShippingTelephoneno:'',
        ShippingFaxno:'',
        ShippingEmailAddress:'',
        Rep1:'',
        Rep2:'',
        Sales1:'',
        Sales2:''
    };
    customerId=0;
    shippingAddressId=0;
    shouldFetchSalesOrderNo=false;
    scal360LicenseDisplayList;
    SelectedCustomerLicenseDetail;
    LicenseRenewalDetails;
    error="";
    SCALRenewalTypeList=[];
    SelectedLicenseKey='';
    isBillingShippingDetailFetched=false;
    selectedLicenseDetailIdList=[];
    selectedNoOfUserRenewalList=[];
    isLoading=false;
    currentTime=Date.now()
    prevSalesOrderNo='';
    constructor(
        private dialogRef:MdDialogRef<RenewScal360LicenseComponent>,
        private formBuilder:FormBuilder,
        private licenseService:LicenseService,
        private appLoader:AppLoaderService,
        private snackBar:MdSnackBar,
        private adalService:AdalService,
        private router:Router,
        @Inject(MD_DIALOG_DATA) public dialogData: any
    ){
        if (!this.adalService.getCachedToken()) {
            this.dialogRef.close(null);
            this.router.navigate(["login"]);
        }
        this.scal360LicenseDisplayList=this.dialogData.Scal360LicenseData;
        this.SelectedCustomerLicenseDetail=this.dialogData.SelectedLicenseDetail;
        this.buildForm();
        this.getScalCustomerLicenseDetail();
        Object.keys(SCALRenewalType).filter((type) => isNaN(Number(type))).forEach((key,index)=>{
            this.SCALRenewalTypeList.push({
                name:key,
                value:SCALRenewalType[key]
            })
        })
        this.billingShippingDetail.BillToName=this.SelectedCustomerLicenseDetail.BillToName;
        this.billingShippingDetail.BillToAddress1=this.SelectedCustomerLicenseDetail.BillToAddress1;
        this.billingShippingDetail.BillToAddress2=this.SelectedCustomerLicenseDetail.BillToAddress2;
        this.billingShippingDetail.BillToCity=this.SelectedCustomerLicenseDetail.BillToCity;
        this.billingShippingDetail.ShipToName=this.SelectedCustomerLicenseDetail.ShipToName;
        this.billingShippingDetail.ShipToAddress1=this.SelectedCustomerLicenseDetail.ShipToAddress1;
        this.billingShippingDetail.ShipToAddress2=this.SelectedCustomerLicenseDetail.ShipToAddress2;
        this.billingShippingDetail.ShipToCity=this.SelectedCustomerLicenseDetail.ShipToCity;
        this.billingShippingDetail.ShipToState=this.SelectedCustomerLicenseDetail.ShipToState;
    }
    buildForm(){
        this.renewScal360LicenseForm=this.formBuilder.group({
            RenewalType:['',[Validators.required]],
            PurchaseDate:['',Validators.required],
            SupportValidityYear:[24,Validators.required],
            SalesOrderNo:['',[Validators.required]],
        })
    }
    selectRow(selectedLicense,index){
        this.selectedRow[index]=(this.selectedRow[index]==index)?null:index;
        this.SelectedLicenseKey=selectedLicense.LicenseKey
    }
    getScalCustomerLicenseDetail(){
        this.isLoading=true;
        this.licenseService.getScalCustomerLicenseDetailForActivationAndRenewal(this.SelectedCustomerLicenseDetail.LicenseId).subscribe((data)=>{
            if(!data.Error && data.DataObject!=null){
                this.LicenseRenewalDetails=data.DataObject;
                this.selectedRow=new Array(this.LicenseRenewalDetails.length).fill(null)
            }
            this.isLoading=false;
        })
    }
    blurSalesOrderEvent(){
        if(this.prevSalesOrderNo.trim().toUpperCase()==this.renewScal360LicenseForm.value.SalesOrderNo.trim().toUpperCase()){
            return;
        }
        this.prevSalesOrderNo=this.renewScal360LicenseForm.value.SalesOrderNo
        setTimeout(() => {
            this.shouldFetchSalesOrderNo=true;
            this.isBillingShippingDetailFetched=false;
        }, 150);
    }
    checkSalesOrderNo(){
        if(this.dialogData.Scal360LicenseData){
            let exists=this.dialogData.Scal360LicenseData.some((element)=>{
                if(element != null){
                    return this.renewScal360LicenseForm.value.SalesOrderNo.toUpperCase().trim()==element.SalesOrderNo.toUpperCase().trim()
                }
                else{
                    return false;
                }
            })
            if(exists){
                Swal.fire({
                    title:"This sales order no already exists",
                    text:"Are you sure you want to use this Sales Order No?",
                    showCancelButton:true,
                    showCloseButton:true,
                    showConfirmButton:true,
                    confirmButtonText:"Yes",
                    confirmButtonColor:"#FFCA28",
                    cancelButtonText:"No",
                }).then((result)=>{
                    if(result.isConfirmed){
                       this.shouldFetchSalesOrderNo=true;
                       this.isBillingShippingDetailFetched=false;
                       this.getBillingShippingDetail();
                    }
                    else{
                        this.shouldFetchSalesOrderNo=false;
                        this.isBillingShippingDetailFetched=false;
                        this.renewScal360LicenseForm.patchValue({
                            SalesOrderNo:""
                        });
                    }
                })
            }
            else{
                this.shouldFetchSalesOrderNo=true;
                this.isBillingShippingDetailFetched=false;
                this.getBillingShippingDetail();
            }
        }
        else{
            this.shouldFetchSalesOrderNo=true;
            this.isBillingShippingDetailFetched=false;
            this.getBillingShippingDetail();
        }
    }
    getBillingShippingDetail(){
        let salesOrderNo=this.renewScal360LicenseForm.value.SalesOrderNo;
        if(salesOrderNo!=''){
            if(this.shouldFetchSalesOrderNo){
                this.appLoader.open()
                this.licenseService.getBillingShippingDetail(salesOrderNo).subscribe((data)=>{
                    if(!data.IsError && data.DataObject!=null){
                        this.billingShippingDetail=data.DataObject;
                        this.isBillingShippingDetailFetched=true;
                        this.error='';
                    }
                    else{
                        this.isBillingShippingDetailFetched=false;
                        this.error=data.Error;
                    }
                    this.appLoader.close()
                })
            }
            else{
                this.error="Please select other sales order number."
            }
        }
        else{
            this.error="Sales Order No is required";
            this.isBillingShippingDetailFetched=false;
        }
    }
    onSave(){
        setTimeout(() => {
            for(let i=0;i<this.selectedRow.length;i++){
                if(this.selectedRow[i]!=null){
                    if(this.LicenseRenewalDetails[i].RenewalUser>this.LicenseRenewalDetails[i].NoOfUser){
                        Swal.fire({
                            title:'Warning',
                            text:'Renewal User cannot be greater than Number of Users.',
                            showConfirmButton:true,
                            confirmButtonColor:'#FFCA28'
                        })
                        this.selectedLicenseDetailIdList=[];
                        this.selectedNoOfUserRenewalList=[];
                       return;
                    }
                    this.selectedLicenseDetailIdList.push(this.LicenseRenewalDetails[i].LicenseDetailId)
                    this.selectedNoOfUserRenewalList.push(this.LicenseRenewalDetails[i].RenewalUser)
                }
            }
            if(this.selectedLicenseDetailIdList.length==0 || this.selectedNoOfUserRenewalList.length==0){
                Swal.fire({
                    title:'Warning',
                    text:'Please select atleast one license.',
                    showConfirmButton:true,
                    confirmButtonColor:'#FFCA28'
                })
               return;
            }
            else if(!this.isBillingShippingDetailFetched){
                this.error="Please fetch the customer billing and shipping details!";
                this.selectedLicenseDetailIdList=[];
                this.selectedNoOfUserRenewalList=[];
                return;
            }

            this.appLoader.open()
            this.licenseService.addBillingShippingDetail(this.billingShippingDetail).subscribe((respData)=>{
                if(!respData.IsError && respData.DataObject!=null){
                    this.customerId=respData.DataObject.CustomerId;
                    this.shippingAddressId=respData.DataObject.ShippingAddressId; 
                    let model={
                        LicenseDetailId:this.selectedLicenseDetailIdList,
                        NoOfUserRenewal:this.selectedNoOfUserRenewalList,
                        LicenseId:this.SelectedCustomerLicenseDetail.LicenseId,
                        RenewType:this.renewScal360LicenseForm.value.RenewalType,
                        SupportValidityMonths:this.renewScal360LicenseForm.value.SupportValidityYear,
                        SCALType:this.SelectedCustomerLicenseDetail.SCALType,
                        PurchaseInvoiceDate:this.renewScal360LicenseForm.value.PurchaseDate,
                        SalesOrderNo:this.renewScal360LicenseForm.value.SalesOrderNo,
                        CustomerId:this.customerId,
                        ShippingAddressId:this.shippingAddressId,
                        TotalNoOfUserLicenses:this.SelectedCustomerLicenseDetail.TotalNoOfUserLicenses,
                        CreatedBy:Number(localStorage.getItem('userid')),
                        UpdatedBy:Number(localStorage.getItem('userid'))
                    }
                    
                    this.licenseService.renewScal360License(model).subscribe((data)=>{
                        if(!data.IsError && data.DataObject!=null){
                            this.scal360LicenseDisplayList=data.DataObject;
                            this.dialogRef.close(this.scal360LicenseDisplayList)
                            this.appLoader.close();
                            this.snackBar.open("License renewed successfully!","",{
                                duration:2000
                            })
                        }
                    })

                }
            });
        }, 300);
    }
    onCancel(){
        this.dialogRef.close(this.scal360LicenseDisplayList);
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/license-portal/scal360/renew-scal360-license/renew-scal360-license.component.ts